const e = new URL("../../assets/icon-community-share-email-D0mduEux.png", import.meta.url).href;
export {
  e as default
};
//# sourceMappingURL=icon-community-share-email.png.js.map
